import React from 'react'
import cardOne from './Images/rowSix/cardOne.jpg'
import cardTwo from './Images/rowSix/cardTwo.jpg'
import cardThree from './Images/rowSix/cardThree.jpg'
import cardFour from './Images/rowSix/cardFour.jpg'
import cardFive from './Images/rowSix/cardFive.jpg'
import cardSix from './Images/rowSix/cardSix.jpg'
import cardSeven from './Images/rowSix/cardSeven.jpg'
import cardEight from './Images/rowSix/cardEight.jpg'
import cardNine from './Images/rowSix/cardNine.jpg'
import { Link } from 'react-router-dom'
export default function Projects() {
    return (
        <div className='py-5' >

          



            <div >

                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-4 my-3">
                            <div style={{ borderRadius: '0px', color: 'white' }} class="card">

                                <div className="imgWrap">

                                    <img style={{ height: '230px', borderRadius: "0px" }} src={cardOne} class="card-img-top" alt="..." />
                                    <div className="imagedescription">
                                        <div className="imgContent">
                                            <p className='really-bold h6'>THE LANGHAM HOTEL</p>
                                            <a href="#"><button style={{ borderRadius: '0px', backgroundColor: '#A10302', color: 'white' }} className="btn">Read More</button></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 my-3">
                            <div style={{ borderRadius: '0px', color: 'white' }} class="card">

                                <div className="imgWrap">

                                    <img style={{ height: '230px', borderRadius: "0px" }} src={cardTwo} class="card-img-top" alt="..." />
                                    <div className="imagedescription">
                                        <div className="imgContent">
                                            <p className='really-bold h6'>FRENCH QUARTER INN</p>
                                            <a href="#"><button style={{ borderRadius: '0px', backgroundColor: '#A10302', color: 'white' }} className="btn">Read More</button></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="healthcare" className="col-12 col-md-4 my-3">
                            <div style={{ borderRadius: '0px', color: 'white' }} class="card">

                                <div className="imgWrap">

                                    <img style={{ height: '230px', borderRadius: "0px" }} src={cardThree} class="card-img-top" alt="..." />
                                    <div className="imagedescription">
                                        <div className="imgContent">
                                            <p className='really-bold h6'>GUADALUPE CLINIC RENOVATION</p>
                                            <a href="#"><button style={{ borderRadius: '0px', backgroundColor: '#A10302', color: 'white' }} className="btn">Read More</button></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="office" className="col-12 col-md-4 my-3">
                            <div style={{ borderRadius: '0px', color: 'white' }} class="card">

                                <div className="imgWrap">

                                    <img style={{ height: '230px', borderRadius: "0px" }} src={cardFour} class="card-img-top" alt="..." />
                                    <div className="imagedescription">
                                        <div className="imgContent">
                                            <p className='really-bold h6'>CLINICAL RESEARCH CENTER</p>
                                            <a href="#"><button style={{ borderRadius: '0px', backgroundColor: '#A10302', color: 'white' }} className="btn">Read More</button></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="interiordesign" className="col-12 col-md-4 my-3">
                            <div style={{ borderRadius: '0px', color: 'white' }} class="card">

                                <div className="imgWrap">

                                    <img style={{ height: '230px', borderRadius: "0px" }} src={cardFive} class="card-img-top" alt="..." />
                                    <div className="imagedescription">
                                        <div className="imgContent">
                                            <p className='really-bold h6'>INSIDE RENOVATION</p>
                                            <a href="#"><button style={{ borderRadius: '0px', backgroundColor: '#A10302', color: 'white' }} className="btn">Read More</button></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 my-3">
                            <div style={{ borderRadius: '0px', color: 'white' }} class="card">

                                <div className="imgWrap">

                                    <img style={{ height: '230px', borderRadius: "0px" }} src={cardSix} class="card-img-top" alt="..." />
                                    <div className="imagedescription">
                                        <div className="imgContent">
                                            <p className='really-bold h6'>RIVERVIEW GREEN BUILDING</p>
                                            <a href="#"><button style={{ borderRadius: '0px', backgroundColor: '#A10302', color: 'white' }} className="btn">Read More</button></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="education" className="col-12 col-md-4 my-3">
                            <div style={{ borderRadius: '0px', color: 'white' }} class="card">

                                <div className="imgWrap">

                                    <img style={{ height: '230px', borderRadius: "0px" }} src={cardSeven} class="card-img-top" alt="..." />
                                    <div className="imagedescription">
                                        <div className="imgContent">
                                            <p className='really-bold h6'>MAGDALEN CATHOLIC SCHOOL</p>
                                            <a href="#"><button style={{ borderRadius: '0px', backgroundColor: '#A10302', color: 'white' }} className="btn">Read More</button></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 my-3">
                            <div style={{ borderRadius: '0px', color: 'white' }} class="card">

                                <div className="imgWrap">

                                    <img style={{ height: '230px', borderRadius: "0px" }} src={cardEight} class="card-img-top" alt="..." />
                                    <div className="imagedescription">
                                        <div className="imgContent">
                                            <p className='really-bold h6'>CHICAGO HOUSE WITH POOL</p>
                                            <a href="#"><button style={{ borderRadius: '0px', backgroundColor: '#A10302', color: 'white' }} className="btn">Read More</button></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="greenbuilding" className="col-12 col-md-4 my-3">
                            <div style={{ borderRadius: '0px', color: 'white' }} class="card">

                                <div className="imgWrap">

                                    <img style={{ height: '230px', borderRadius: "0px" }} src={cardNine} class="card-img-top" alt="..." />
                                    <div className="imagedescription">
                                        <div className="imgContent">
                                            <p className='really-bold h6'>GREEN HOUSE NEIGHBOURHOOD</p>
                                            <a href="#"><button style={{ borderRadius: '0px', backgroundColor: '#A10302', color: 'white' }} className="btn">Read More</button></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/services copy 7.jsx